import {
    IProps,
    IRef,
} from './types';

import React, {
    forwardRef,
    useImperativeHandle,
} from 'react';

import {
    useInputMask,
} from 'tools/hooks';

import StringInput from '../StringInput';

import {
    MASK,
} from './constants';
import {
    formatInitialValue,
    formatValue,
} from './functions';

const NumberInput = forwardRef<IRef, IProps>((props, ref) => {
    const {value, setValue, inputProps} = useInputMask({
        value: formatInitialValue(props.value),
        mask: MASK,
        onChange(value: string) {
            let formattedValue = formatValue(value);

            if (formattedValue !== null) {
                if (props.min !== undefined) {
                    if (formattedValue < props.min) {
                        formattedValue = props.min;
                        setValue(formatInitialValue(formattedValue));
                    }
                }
                if (props.max !== undefined) {
                    if (formattedValue > props.max) {
                        formattedValue = props.max;
                        setValue(formatInitialValue(formattedValue));
                    }
                }
            }

            props.onChangeValue?.(formattedValue);
        },
    });

    useImperativeHandle(ref, () => {
        return {
            setValue(value: number | null) {
                setValue(formatInitialValue(value));
            },
        };
    });

    return (
        <StringInput
            className={props.className}
            value={value}
            size={props.size}
            label={props.label}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            isError={props.isError}
            errorMessage={props.errorMessage}
            {...inputProps}
        />
    );
});

export default NumberInput;
